(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('sc3ClassicRedirect', sc3ClassicRedirect);

    var
        parser = document.createElement('a'),
        noop = angular.noop,
        classicViewRegEx = /mem\.golfcanada\.ca/i;

    sc3ClassicRedirect.$inject = ['$window', 'user', 'OpenId', 'alert', 'shared_resources', 'classicViewTokenParam', 'classicViewModal'];
    function sc3ClassicRedirect($window, user, OpenId, alert, resources, classicViewTokenParam, classicViewModal) {
        return {
            restrict: 'A',
            link: link
        };

        function link(scope, element, attrs) {
            element.on('click', click);

            function click(e) {
                var href = element.prop('href'),
                    target = element.prop('target'),
                    altHref = attrs['href'],
                    openInNewWindow = target === '_blank',
                    tokenParam = attrs['renewal'],                    
                    isRenewaltoken = tokenParam === 'renewalToken',
                    newWindow;

                href = href ? href : altHref;

                if (href) {
                    e.preventDefault();
                    if (classicViewRegEx.test(href))
                        classicViewModal().result.then(redirect, redirect);
                    else
                        redirect();
                }

                function redirect() {                                      
                    if ((href.indexOf("mem.golfcanada") >= 0 && (user.isAdmin || user.isHandicapChair)) || (href.indexOf("mobileapi.golfcanada") > 0 && user.isAdmin) || (href.indexOf("herokuapp") > 0 && user.isAdmin) || (href.indexOf("tms") >= 0 && user.isTournamentAdmin) || (href.indexOf("ecomm") >= 0)) {
                        if (openInNewWindow) {
                            newWindow = $window.open('', '_blank');
                            newWindow.document.write("Loading...");
                        }

                        OpenId.getNgnToken(success, error, true);
                    }
                }

                function success(data) {
                    parser.href = href;
                    parser.search += (parser.search ? '&' : '?') + encodeURIComponent(isRenewaltoken ? 'renewalToken' : classicViewTokenParam) + '=' + encodeURIComponent(data.token);
                    if (openInNewWindow)
                        newWindow.location.href = parser.href; // $window.open(parser.href)
                    else
                        $window.location.href = parser.href;
                }
                function error() {
                    if (newWindow)
                        newWindow.close();
                    alert.error(resources.ngnTokenRequestFailed);
                }
            }
        }
    }
})();
